module.exports = __webpack_public_path__ + "img/PHF_LOGO_WHITE.3623e651.svg";